import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { EXPLORE_TABS } from '../../../constants/app-constants';
import Auctions from './auctions';
import PropTypes from 'prop-types';
import CircleIcon from '@mui/icons-material/Circle';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { prepareGADataAndSendEvent } from '../../../tracking';
import UpdateAppModal from '../../common/update-app-modal';
const AuctionList = (props) => {
    const { type } = props?.auctionsList || {};

    const handleTabChange = (e, value) => {
        prepareGADataAndSendEvent('auctionsFilter', props?.user, null, 'Combined auctions page', { eventLabel: value?.join(',') });
        props.setAuctionTypeFlagConnect(value);
    };

    const isSelected = (value) => {
        return type?.includes(value);
    };
    return (
        <div className='relative -mt-3'>
            <ToggleButtonGroup className='pb-6 gap-4 pr-8' sx={{ width: '88%' }}
                value={type}
                fullWidth size='small'
                onChange={handleTabChange}
                aria-label="text formatting"
            >
                {EXPLORE_TABS.map(({ label, value, color }, idx) => (
                    <ToggleButton key={idx} className={`${isSelected(value) ? 'bg-tab-bg' : 'bg-light-border'} text-base border-none rounded opacity-50 p-1`} classes={{ selected: 'opacity-100' }} sx={{ borderRadius: '0.25rem!important' }} value={value} aria-label={label}>
                        <span className='flex items-center justify-around w-full gap-1 capitalize'>
                            <span className='flex items-center gap-1'>
                                <CircleIcon className={`h-4 w-4 text-${color}`} />
                                <span>{label}</span>
                            </span>
                            {isSelected(value) ? <CheckBoxIcon className={`font-semibold text-primary h-5 w-5`} /> : <CheckBoxOutlineBlankOutlinedIcon className={`font-semibold text-primary h-5 w-5`} />}
                        </span>
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            <Auctions {...props} auctionType={type} />
            <UpdateAppModal page={'auction-list'} />
        </div>
    );
};

AuctionList.propTypes = {
    setAuctionTypeFlagConnect: PropTypes.func,
    auctionsList: PropTypes.object,
    user: PropTypes.object
};

export default AuctionList;
